import moment from 'moment';
import React from 'react';
function RtRecordingTime({ record }) {
    return (React.createElement("div", { className: 'rt-recording' },
        React.createElement("span", { className: '' },
            "Recording summery:  ",
            moment(record.start).format('HH:mm'),
            " - ",
            moment(record.end).format('HH:mm, MMM DD, YYYY')),
        React.createElement("span", { className: 'ml-5' },
            "Total Recording Time: ",
            Math.floor(record.total / 60),
            " minutes ",
            record.total % 60,
            " seconds")));
}
export default RtRecordingTime;
